import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { environment } from '../../../environments/environment';
import { IFeature, IModifyFeature } from "../../common/models/feature.model";
import { mapFeatureResponse } from "../../common/models/helpers";

@Injectable({
    providedIn: 'root'
})
export class FeatureManagementService {
    private httpClient = inject(HttpClient);

    private static readonly endpoints = {
        getFeatures: `${environment.apiUrl}/features`,
        addModifyFeature: `${environment.apiUrl}/feature`,
    };

    getAllFeatures(): Observable<IFeature[]> {
        const ERROR_MESSAGE = "Failed to get features";
        return this.httpClient.get<any[]>(FeatureManagementService.endpoints.getFeatures).pipe(
            map((response: any[]) => {
                return response.map(response => mapFeatureResponse(response));
            }),
            catchError(error => {
                console.error(ERROR_MESSAGE, error);
                return throwError(() => new Error(ERROR_MESSAGE));
            })
        )
    }

    getFeature(featureId: string): Observable<IFeature> {
        const ERROR_MESSAGE = `Failed to feature with ${featureId}`;
        return this.httpClient.get<any>(`${FeatureManagementService.endpoints.getFeatures}/${featureId}`).pipe(
            map((response: any) => {
                return mapFeatureResponse(response);
            }),
            catchError(error => {
                console.error(ERROR_MESSAGE, error);
                return throwError(() => new Error(ERROR_MESSAGE));
            })
        )
    }

    addFeature(newFeature: IModifyFeature): Observable<IFeature> {
        const ERROR_MESSAGE = `Failed to add feature`;
        return this.httpClient.post(`${FeatureManagementService.endpoints.addModifyFeature}`, newFeature).pipe(
            map((response: any) => {
                return mapFeatureResponse(response);
            }),
            catchError(error => {
                console.error(ERROR_MESSAGE, error);
                return throwError(() => new Error(ERROR_MESSAGE));
            })
        )
    }

    modifyFeature(modifiedFeature: IFeature): Observable<IFeature> {
        const ERROR_MESSAGE = `Failed to modify feature`;
        return this.httpClient.put(`${FeatureManagementService.endpoints.addModifyFeature}`, modifiedFeature).pipe(
            map((response: any) => {
                return mapFeatureResponse(response);
            }),
            catchError(error => {
                console.error(ERROR_MESSAGE, error);
                return throwError(() => new Error(ERROR_MESSAGE));
            })
        )
    }

    deleteFeature(feature_id: string): Observable<IFeature> {
        const ERROR_MESSAGE = `Failed to delete feature`;
        return this.httpClient.delete(`${FeatureManagementService.endpoints.addModifyFeature}/${feature_id}`).pipe(
            map((response: any) => {
                return mapFeatureResponse(response);
            }),
            catchError(error => {
                console.error(ERROR_MESSAGE, error);
                const serverMessage = error?.error?.message ?? ERROR_MESSAGE;
                return throwError(() => new Error(serverMessage));
            })
        )
    }
}
